import { render, staticRenderFns } from "./PopupSelect.vue?vue&type=template&id=c03c2810&scoped=true&"
import script from "./PopupSelect.vue?vue&type=script&lang=js&"
export * from "./PopupSelect.vue?vue&type=script&lang=js&"
import style0 from "./PopupSelect.vue?vue&type=style&index=0&id=c03c2810&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03c2810",
  null
  
)

export default component.exports